import { Component, EventEmitter, Input, Output } from '@angular/core';
import { APPOINTMENT_SLOT_STATUS, AppointmentPeriodModel, UiResponsiveService } from '@evorait/pace-core';
import { Observable } from 'rxjs';
import { faBan } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-appointment-slot-row',
    templateUrl: './appointment-slot-row.component.html',
    standalone: false,
})
export class AppointmentSlotRowComponent {
    @Input() public row: AppointmentPeriodModel;
    @Input() public index: number;

    @Output() public slotSelect = new EventEmitter<number>();

    protected readonly APPOINTMENT_SLOT_STATUS = APPOINTMENT_SLOT_STATUS;
    public isMobile$: Observable<boolean>;
    public readonly faBan = faBan;

    public constructor(private readonly uiResponsiveService: UiResponsiveService) {
        this.isMobile$ = this.uiResponsiveService.isMobile$;
    }

    public selectSlot(): void {
        this.slotSelect.emit(this.index);
    }
}
